/**
 * @description 对图片宽度在允许规范内向上取整
 * @param w
 * @returns
 */
export const _getImageWidth = (w?: number): number => {
  w = w || 0;
  // 新增图片尺寸规则
  let retWidth = w;
  const widthArray = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];

  const length = widthArray.length;
  for (let i = 0; i < length; i++) {
    // console.log(`${i} width:${widthArray[i]}`)
    if (widthArray[i] >= w || i === length - 1) {
      retWidth = widthArray[i];
      break;
    }
  }
  return retWidth;
};
